import { render, staticRenderFns } from "./model_list.vue?vue&type=template&id=400d5dc5&scoped=true"
import script from "./model_list.vue?vue&type=script&lang=js"
export * from "./model_list.vue?vue&type=script&lang=js"
import style0 from "./model_list.vue?vue&type=style&index=0&id=400d5dc5&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d5dc5",
  null
  
)

export default component.exports